// Features that are on by default — only hidden when explicitly disabled.
// Everything else is opt-in: hidden unless the flag is truthy.
const DEFAULT_ON_FEATURES = new Set([
  'FEATURE_DATA_EXPLORER',
  'FEATURE_FAMILY_HISTORY_QUESTIONNAIRE',
  'FEATURE_FAMILY_RECORD_MANAGEMENT',
  // Global quick-actions menu: enabled by default so it can be tested / rolled
  // out; a deployment can still opt out with FEATURE_GLOBAL_QUICK_ACTIONS: false.
  // (Move this back out of the set to return to strict opt-in / default-off.)
  'FEATURE_GLOBAL_QUICK_ACTIONS'
]);

export function isFeatureEnabled(requiredFeature, systemFeatures) {
  if (!requiredFeature) return true;
  if (DEFAULT_ON_FEATURES.has(requiredFeature)) {
    return systemFeatures?.[requiredFeature] !== false;
  }
  return !!systemFeatures?.[requiredFeature];
}
